/**
 * Mediatabs component. It displays photospanel, stickerspanel, backgroundspanel, layoutspanel and texts panels.
 * @constructor editor.mediatabs.MediaTabs
 * @param {object} dom DOM
 */

fx.ns("desktop.common.panels", class MediaTabs extends fx.Component{
    
	constructor(data)
	{
		super(data);
		this.assets = fx.get("assets");

		this.effect = "hslidein";
	}

	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		//if (val != this._currentArea)
		//{
			this._currentArea = val;

			if (this.layoutPanel)
				this.layoutPanel.currentArea = this.currentArea;
		//}
	}

	create()
	{
		super.create();

		this.tabs = new fx.components.TabsHorizontal();

        this.photoPanel = new desktop.common.panels.PhotosPanel(  this.data, {automaticPlacingDisabled : this.data.iaEnabled } );
		this.stickerPanel = new desktop.common.panels.StickersPanel( this.data );
		this.backgroundPanel = new desktop.common.panels.BackgroundsPanel(  this.data );
		this.textPanel = new desktop.common.panels.TextsPanel( this.data );
		this.layoutPanel = new desktop.book.edition.LayoutsPanel( this.data );
		
		this.tabs.addTab(fx.text("Photos"), this.assets.PhotoTab, this.photoPanel, true);
		this.tabs.addTab(fx.text("Modèles"), this.assets.LayoutTab, this.layoutPanel);
		this.tabs.addTab(fx.text("Textes"), this.assets.TextTab, this.textPanel);
		this.tabs.addTab(fx.text("Fonds"), this.assets.BackgroundTab, this.backgroundPanel);
		this.tabs.addTab(fx.text("Stickers"), this.assets.StickerTab, this.stickerPanel);

		// show layouts when creating at first or when no pictures uploaded yet
        if(fx.get("app") != "config" && this.isCreating() )
			this.tabs.selectTab( this.layoutPanel );
		
		
		this.addChild(this.tabs,  {width:"100%", height: "100%"});
	}

	onReady(){
		super.onReady();

        this.listenUpdates( this.data.photos, true );
	
	}

	/*_selectLayoutPanel()
	{
		this.tabs.selectTab(this.layoutPanel);
	}*/

	resetScroll()
	{
		if (this.tabs.currentPanel)
			this.tabs.currentPanel.panel.resetScroll()
	}

	// We listen to updates on photos, so we can update photos count
	onChildUpdated(action)
	{
		this.onDataUpdated(action);
	}
	// We listen to updates on photos, so we can update photos count
	onDataUpdated(action)
	{
		super.onDataUpdated(action);

		if (this.tabs && this.data && this.data.photos)
			this.tabs.setNumber(this.photoPanel, this.data.photos.count);
	}

	selectTabForElement(element)
	{
        if(element)
        {
            if (element.className == "Photo" || (this._lastElement && this._lastElement == element))

            switch (element.className)
            {
                case "Text":
                    this.tabs.selectTab(this.textPanel);
                    break;
                case "Photo":
                    this.tabs.selectTab(this.photoPanel);
                    break;
                case "Shape":
                case "Sticker":
                    this.tabs.selectTab(this.stickerPanel);
                    break;
                case "Background":
                    this.tabs.selectTab(this.backgroundPanel);
                    break;
                case "Layout":
                    this.tabs.selectTab(this.layoutsPanel);
                    break;
            } 
        }   
    

		this._lastElement = element;
	}

	isCreating()
	{
		// case when we want to show layouts first : no theme selected, only theme category.
		return (fx.browser.urlPathParts[0] == "create");
	}

	selectFilter(index)
	{
		this.photoPanel.selectFilter(index);
	}

	selectFilter(index)
	{
		this.photoPanel.selectFilter(index);
	}
});
